import { uiText, useUiLanguage } from '../../utils/uiTranslation';
/**
 * Notification item component for approval requests
 * Shows approval details and opens the review flow
 */
import React from 'react';

const ApprovalNotificationItem = ({
    approval,
    onViewDetails
}) => {
  useUiLanguage();
    const getIcon = () => {
        if (approval.type === 'job_posting') {
            return 'fa-solid fa-briefcase';
        }
        return 'fa-solid fa-envelope-open-text';
    };

    const getTitle = () => {
        if (approval.type === 'job_posting') {
            return uiText('Job Posting Approval');
        }
        return uiText('Offer Letter Approval');
    };

    const formatTime = (timestamp) => {
        if (!timestamp) return '';
        const diff = Date.now() - timestamp;
        const mins = Math.floor(diff / 60000);
        if (mins < 1) return uiText('Just now');
        if (mins < 60) return uiText("{{count}}m ago", { count: mins });
        const hours = Math.floor(mins / 60);
        if (hours < 24) return uiText("{{count}}h ago", { count: hours });
        const days = Math.floor(hours / 24);
        return uiText("{{count}}d ago", { count: days });
    };

    const submittedByLabel = (() => {
        if (approval.submittedBy && typeof approval.submittedBy === 'object') {
            return approval.submittedBy.name || approval.submittedBy.email || approval.submittedByEmail || 'Unknown';
        }
        if (typeof approval.submittedBy === 'string') {
            return approval.submittedBy.includes('@') ? approval.submittedBy : (approval.submittedByEmail || 'Unknown');
        }
        return approval.submittedByEmail || 'Unknown';
    })();

    return (
        <div
            style={{
                padding: '16px',
                borderBottom: "1px solid var(--app-border, rgba(86, 141, 237, 0.1))",
                backgroundColor: 'var(--app-surface, rgba(86, 141, 237, 0.03))'
            }}
        >
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                <div style={{
                    width: '36px',
                    height: '36px',
                    borderRadius: '8px',
                    backgroundColor: 'rgba(255, 193, 7, 0.15)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                }}>
                    <i className={getIcon()} style={{ color: 'var(--app-tone-ffc107, #ffc107)', fontSize: '14px' }} />
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '4px' }}>
                        <span style={{ fontFamily: 'Montserrat', fontWeight: 600, color: '#1A1D1F', fontSize: '13px' }}>
                            {getTitle()}
                        </span>
                        <span style={{ fontFamily: 'Montserrat', color: '#6c757d', fontSize: '11px' }}>
                            {formatTime(approval.submittedAt)}
                        </span>
                    </div>
                    <p style={{ fontFamily: 'Montserrat', color: '#1A1D1F', fontSize: '13px', margin: '0 0 8px 0' }}>
                        <strong>"{approval.snapshot?.title || uiText("Untitled")}"</strong>{uiText(" needs your approval")}</p>
                    <p style={{ fontFamily: 'Montserrat', color: '#6c757d', fontSize: '12px', margin: '0 0 12px 0' }}>{uiText("Submitted by: ")}{submittedByLabel}
                    </p>

                    <div style={{ display: 'flex', gap: '8px' }}>
                        <button
                            onClick={() => onViewDetails && onViewDetails(approval)}
                            style={{ '--light-control-fill': '#568ded',
                                padding: '8px 16px',
                                borderRadius: '6px',
                                border: 'none',
                                backgroundColor: '#568ded',
                                color: '#FFFFFF',
                                fontFamily: 'Montserrat',
                                fontSize: '13px',
                                fontWeight: 600,
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                width: '100%',
                                justifyContent: 'center'
                            }}
                          data-light-control={"filled"}>
                            <i className="fa-solid fa-file-signature"></i>
                            {approval.type === 'job_posting' ? uiText("Review Job") : uiText("Review Offer")}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ApprovalNotificationItem;
